import React from 'react';
import { Typography, Chip } from '@mui/material';
import { ProblemStatus } from '../../../models/Problem';

interface ProblemDescriptionProps {
  description: string;
  status: ProblemStatus;
}

const ProblemDescription: React.FC<ProblemDescriptionProps> = ({ description, status }) => (
  <>
    <Typography variant="body1" mb={2} marginTop={2}>
      {description}
    </Typography>
    <Chip
      label={status}
      color={
        status === 'open'
          ? 'primary'
          : status === 'closed'
          ? 'default'
          : status === 'in_progress'
          ? 'secondary'
          : 'success'
      }
      sx={{ mb: 2 }}
    />
  </>
);

export default ProblemDescription;
